import { render } from "./NewsDetailView.vue?vue&type=template&id=30a912fc"
import script from "./NewsDetailView.vue?vue&type=script&lang=js"
export * from "./NewsDetailView.vue?vue&type=script&lang=js"

import "./NewsDetailView.vue?vue&type=style&index=0&id=30a912fc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__